// const cells = document.querySelectorAll('.Carousel__Cell');
// const carouselEl = document.querySelector('.ProductList--carousel');

// const flkty = carouselEl ? window.Flickity.data(carouselEl) : null;

// console.log(`=== ${cells.length} CAROUSEL CELLS FOUND ===`);
// console.log('Flickity instance:', flkty ? 'Found ✅' : 'Not found ❌');

// cells.forEach((cell, cellIndex) => {
//   const img = cell.querySelector('img[data-media-id]');
//   const imageWrapper = cell.querySelector('.ProductItem__ImageWrapper');

//   // ========== SWIPE = CAROUSEL SCROLL ==========
//   if (imageWrapper) {
//     let touchStartX = 0;
//     let touchStartY = 0;
//     let startScrollLeft = 0;

//     imageWrapper.addEventListener('touchstart', (e) => {
//       touchStartX = e.touches[0].clientX;
//       touchStartY = e.touches[0].clientY;
//       startScrollLeft = carouselEl.scrollLeft;
//       e.stopPropagation();
//     }, { passive: false });

//     imageWrapper.addEventListener('touchmove', (e) => {
//       const diffX = e.touches[0].clientX - touchStartX;
//       const diffY = Math.abs(e.touches[0].clientY - touchStartY);
//       const absDiffX = Math.abs(diffX);

//       if (absDiffX > diffY && absDiffX > 10) {
//         e.preventDefault();
//         e.stopPropagation();

//         carouselEl.scrollLeft = startScrollLeft - diffX;
//       }
//     }, { passive: false });

//     imageWrapper.addEventListener('touchend', (e) => {
//       e.stopPropagation();
//     }, { passive: false });
//   }

//   // ========== IMAGE TRACKING ==========
//   if (!img) {
//     console.log(`[Cell ${cellIndex + 1}] No image found`);
//     return;
//   }

//   console.log(`[Cell ${cellIndex + 1}] Default:`, {
//     src: img.src,
//     mediaId: img.getAttribute('data-media-id'),
//     alt: img.alt
//   });

//   const descriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');

//   Object.defineProperty(img, 'src', {
//     get() {
//       return descriptor.get.call(this);
//     },
//     set(newVal) {
//       console.log(`=== CELL ${cellIndex + 1} - SRC CHANGED ===`);
//       console.log('Old src:', descriptor.get.call(this));
//       console.log('New src:', newVal);
//       console.log('media-id:', img.getAttribute('data-media-id'));
//       descriptor.set.call(this, newVal);
//     }
//   });

//   const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       console.log(`=== CELL ${cellIndex + 1} - ATTRIBUTE CHANGED ===`);
//       console.log('Attribute:', mutation.attributeName);
//       console.log('New src:', img.src);
//     });
//   });

//   observer.observe(img, {
//     attributes: true,
//     attributeFilter: ['src', 'srcset', 'data-media-id', 'alt']
//   });
// });


const carousels = document.querySelectorAll('.ProductList--carousel');

carousels.forEach((carouselEl) => {
  const cells = carouselEl.querySelectorAll('.Carousel__Cell');

  cells.forEach((cell) => {
    const img = cell.querySelector('img[data-media-id]');
    const imageWrapper = cell.querySelector('.ProductItem__ImageWrapper');

    // ========== SWIPE = CAROUSEL SCROLL ==========
if (imageWrapper) {
      let touchStartX = 0;
      let touchStartY = 0;
      let startScrollLeft = 0;
      let lastX = 0;
      let lastTime = 0;
      let velocity = 0;
      let momentumId = null;

      imageWrapper.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        startScrollLeft = carouselEl.scrollLeft;
        lastX = touchStartX;
        lastTime = Date.now();
        velocity = 0;
        if (momentumId) {
          cancelAnimationFrame(momentumId);
          momentumId = null;
        }
        e.stopPropagation();
      }, { passive: false });

      imageWrapper.addEventListener('touchmove', (e) => {
        const diffX = e.touches[0].clientX - touchStartX;
        const diffY = Math.abs(e.touches[0].clientY - touchStartY);
        const absDiffX = Math.abs(diffX);

        if (absDiffX > diffY && absDiffX > 10) {
          e.preventDefault();
          e.stopPropagation();

          carouselEl.scrollLeft = startScrollLeft - diffX;

          const now = Date.now();
          const dt = now - lastTime;
          if (dt > 0) {
            velocity = (e.touches[0].clientX - lastX) / dt;
          }
          lastX = e.touches[0].clientX;
          lastTime = now;
        }
      }, { passive: false });

      imageWrapper.addEventListener('touchend', (e) => {
        e.stopPropagation();

        let currentVelocity = velocity;
        const friction = 0.95;

        function momentumStep() {
          carouselEl.scrollLeft -= currentVelocity * 16;
          currentVelocity *= friction;
          if (Math.abs(currentVelocity) > 0.02) {
            momentumId = requestAnimationFrame(momentumStep);
          } else {
            momentumId = null;
          }
        }

        if (Math.abs(currentVelocity) > 0.05) {
          momentumId = requestAnimationFrame(momentumStep);
        }
      }, { passive: false });
    }

    // ========== IMAGE TRACKING ==========
    if (!img) return;

    const descriptor = Object.getOwnPropertyDescriptor(
      HTMLImageElement.prototype,
      'src'
    );

    Object.defineProperty(img, 'src', {
      get() {
        return descriptor.get.call(this);
      },
      set(newVal) {
        descriptor.set.call(this, newVal);
      }
    });

    const observer = new MutationObserver(() => {});

    observer.observe(img, {
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-media-id', 'alt']
    });
  });
});